<script setup>
defineProps({
    formButtonConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                label: rawValue => typeof rawValue?.label === 'string',
                buttonConfig: rawValue => typeof rawValue?.buttonConfig === 'object'
            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})
</script>

<template>
    <div class="form-submit-wrapper">
        <BaseButton :base-button-config="formButtonConfig.buttonConfig">
            {{ formButtonConfig.label }}
        </BaseButton>
    </div>
</template>

<style lang="scss">
.form-submit-wrapper {
    position: relative;
    margin-block-start: px2rem(40);
}
</style>
